
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      offset={16}
      gap={8}
      toastOptions={{
        duration: 3500,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-border/60 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl group-[.toaster]:text-sm",
          title:
            "group-[.toast]:font-medium group-[.toast]:text-sm",
          description:
            "group-[.toast]:text-muted-foreground group-[.toast]:text-xs",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:text-xs group-[.toast]:font-medium group-[.toast]:rounded-md group-[.toast]:px-2.5 group-[.toast]:py-1",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:text-xs group-[.toast]:rounded-md group-[.toast]:px-2.5 group-[.toast]:py-1",
          success:
            "group-[.toaster]:border-emerald-200 dark:group-[.toaster]:border-emerald-800",
          error:
            "group-[.toaster]:border-red-200 dark:group-[.toaster]:border-red-800",
          closeButton:
            "group-[.toast]:bg-background group-[.toast]:border-border/60",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
